var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-create main-content" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitSupplierData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$t("suppliers.new_supplier"))),
          ]),
          _vm._v(" "),
          _c("ol", { staticClass: "breadcrumb" }, [
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "item-title", to: "/anchor/dashboard" },
                    slot: "item-title",
                  },
                  [_vm._v(_vm._s(_vm.$t("general.home")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "item-title", to: "/anchor/suppliers" },
                    slot: "item-title",
                  },
                  [_vm._v(_vm._s(_vm.$tc("suppliers.supplier", 2)))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("li", { staticClass: "breadcrumb-item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("suppliers.new_supplier")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-actions header-button-container" },
            [
              _c(
                "base-button",
                {
                  attrs: {
                    loading: _vm.isLoading,
                    disabled: _vm.isLoading,
                    tabindex: 23,
                    icon: "save",
                    color: "theme",
                    type: "submit",
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("suppliers.save_supplier")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "customer-card card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "section-title col-sm-2" }, [
                _vm._v(_vm._s(_vm.$tc("suppliers.supplier", 2))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-10" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("base-select", {
                      attrs: {
                        options: _vm.supplierUsersType,
                        searchable: true,
                        "show-labels": false,
                        "allow-empty": true,
                        tabindex: 8,
                        placeholder: _vm.$t("suppliers.select_supplier"),
                        label: "company_name",
                        "track-by": "id",
                      },
                      on: { select: _vm.referData },
                      model: {
                        value: _vm.referUser,
                        callback: function ($$v) {
                          _vm.referUser = $$v
                        },
                        expression: "referUser",
                      },
                    }),
                    _vm._v(" "),
                    _vm.$v.referUser.$error
                      ? _c("div", [
                          !_vm.$v.referUser.required
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$tc("validation.required")) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "section-title col-sm-2" }, [
                _vm._v(_vm._s(_vm.$t("suppliers.basic_info"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.display_name"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _vm.formData.name
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.formData.name) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.email"))),
                  ]),
                  _vm._v(" "),
                  _vm.formData.email
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.formData.email) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.primary_currency"))),
                  ]),
                  _vm._v(" "),
                  _vm.currency
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currencyNameWithCode(_vm.currency)
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("general.payment_term"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c("base-input", {
                      attrs: {
                        label: _vm.$t("general.tenor"),
                        type: "text",
                        "tab-index": "2",
                      },
                      model: {
                        value: _vm.formData.tenor,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formData,
                            "tenor",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "formData.tenor",
                      },
                    }),
                    _vm._v(" "),
                    _vm.$v.formData.tenor.$error
                      ? _c("div", [
                          !_vm.$v.formData.tenor.required
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$tc("validation.required")) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.primary_contact_name"))),
                  ]),
                  _vm._v(" "),
                  _vm.formData.contact_name
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.formData.contact_name),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.phone"))),
                  ]),
                  _vm._v(" "),
                  _vm.formData.phone
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.formData.phone) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.website"))),
                  ]),
                  _vm._v(" "),
                  _vm.formData.website
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.formData.website),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("general.supplier_id"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c("base-input", {
                      attrs: {
                        label: _vm.$t("general.supplier_id"),
                        "aria-required": "true",
                        type: "text",
                        "tab-index": "2",
                      },
                      model: {
                        value: _vm.formData.supplier_id,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formData,
                            "supplier_id",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "formData.supplier_id",
                      },
                    }),
                    _vm._v(" "),
                    _vm.$v.formData.supplier_id.$error
                      ? _c("div", [
                          !_vm.$v.formData.supplier_id.required
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$tc("validation.required")) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "section-title col-sm-2" }, [
                _vm._v(_vm._s(_vm.$t("suppliers.billing_address"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.name"))),
                  ]),
                  _vm._v(" "),
                  _vm.billing.name
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.billing.name) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.state"))),
                  ]),
                  _vm._v(" "),
                  _vm.billing.state
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.billing.state) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.address"))),
                  ]),
                  _vm._v(" "),
                  _vm.billing.address_street_1
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.billing.address_street_1),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.billing.address_street_2
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.billing.address_street_2),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.country"))),
                  ]),
                  _vm._v(" "),
                  _vm.billing_country && _vm.billing_country.name
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.billing_country.name),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.city"))),
                  ]),
                  _vm._v(" "),
                  _vm.billing.city
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.billing.city) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.phone"))),
                  ]),
                  _vm._v(" "),
                  _vm.billing.phone
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.billing.phone) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.zip_code"))),
                  ]),
                  _vm._v(" "),
                  _vm.billing.zip
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.billing.zip) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "section-title col-sm-2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("suppliers.shipping_address")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.name"))),
                  ]),
                  _vm._v(" "),
                  _vm.shipping.name
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.shipping.name) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.state"))),
                  ]),
                  _vm._v(" "),
                  _vm.shipping.state
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.shipping.state) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.address"))),
                  ]),
                  _vm._v(" "),
                  _vm.shipping.address_street_1
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.shipping.address_street_1),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shipping.address_street_2
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.shipping.address_street_2),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.country"))),
                  ]),
                  _vm._v(" "),
                  _vm.shipping_country && _vm.shipping_country.name
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.shipping_country.name),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.city"))),
                  ]),
                  _vm._v(" "),
                  _vm.shipping.city
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.shipping.city) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.phone"))),
                  ]),
                  _vm._v(" "),
                  _vm.shipping.phone
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.shipping.phone) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("suppliers.zip_code"))),
                  ]),
                  _vm._v(" "),
                  _vm.shipping.zip
                    ? _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.shipping.zip) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group collapse-button-container" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "collapse-button",
                        attrs: {
                          tabindex: 23,
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("suppliers.save_supplier")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }